import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { TPipe } from '../../../../shared/pipes';
import { AppModalComponent } from '../../../../shared/ui/modal/app-modal.component';
import { OnboardingChecklistStore } from '../../stores/onboarding-checklist.store';

@Component({
  selector: 'app-checklist-completion-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, TPipe, AppModalComponent],
  template: `
    <app-modal
      [visible]="store.celebrationTrigger()"
      [size]="'sm'"
      [showCloseButton]="false"
      [closeOnOverlay]="false"
      [closeOnEscape]="false"
      [showFooter]="false"
      [stackAbove]="true"
    >
      <div modalBody class="flex flex-col items-center text-center gap-4 px-2 py-6">
        <span
          class="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[var(--accent-soft)] text-[var(--accent)]"
        >
          <lucide-icon name="party-popper" [size]="40" aria-hidden="true"></lucide-icon>
        </span>
        <h2 class="text-lg font-semibold text-[var(--text)]">
          {{ 'onboardingChecklist.celebration.title' | t }}
        </h2>
        <p class="text-sm text-[var(--muted)]">
          {{ 'onboardingChecklist.celebration.subtitle' | t }}
        </p>
        <button
          type="button"
          class="mt-2 inline-flex items-center justify-center rounded-xl bg-[var(--accent)] px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
          (click)="onClose()"
        >
          {{ 'onboardingChecklist.celebration.button' | t }}
        </button>
      </div>
    </app-modal>
  `,
})
export class ChecklistCompletionModalComponent {
  protected readonly store = inject(OnboardingChecklistStore);

  protected async onClose(): Promise<void> {
    try {
      await this.store.dismiss();
    } catch {
      // celebracao ja foi fechada otimisticamente; erro de rede e ignorado aqui.
    }
  }
}
